import { put, select } from "redux-saga/effects";
import { getZapierZapsSuccess, getZapierZapsFailure } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleGetZapierZaps() {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { data } = yield IntegrationService.getZapierZaps(formId);
        yield put(
            getZapierZapsSuccess({
                data: data.zaps,
                success: data.success,
                message: data.message,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to get zapier zaps";
        console.error("Error getting zapier zaps:", error);
        yield put(getZapierZapsFailure(errorMessage));
    }
}
